module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB9SURBVHgB1ZHvDUAwEMUf8dkGTGABCxiICQygNjCBcRjBAiZwlWuINDnHB/pLXvqatC/3B/iaiM+a1EBHRzLuskDP/ifGS6QAgwcBdh4j+4LUs29Jw/Vx4gnISCn7CcegS1J1pwIbsLLPT2GzrwLHf7cg4oZo16VtQ1xxIGxZHQ9erFE77gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/englishVoice/icon_check_word.png
// module id = WPC8
// module chunks = 4